import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Small delay to prevent flash on page load
    const timer = setTimeout(() => {
      const consent = localStorage.getItem('rtk-cookie-consent');
      if (!consent) {
        setShowBanner(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('rtk-cookie-consent', 'accepted');
    setShowBanner(false);
    
    // Enable Google Analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
      });
    }
  };

  const declineCookies = () => {
    localStorage.setItem('rtk-cookie-consent', 'declined');
    setShowBanner(false);
    
    // Disable Google Analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
      });
    }
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9998,
        }} 
      />
      
      {/* Banner */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#1C1C1C',
        borderTop: '1px solid #333',
        padding: '24px',
        zIndex: 9999,
        fontFamily: "'TASA Orbiter Display', sans-serif",
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
        }}>
          {/* Text Content */}
          <div>
            <h3 style={{
              color: '#F1F1F1',
              fontSize: '16px',
              margin: '0 0 8px 0',
              fontWeight: '500',
            }}>
              We value your privacy
            </h3>
            <p style={{
              color: '#8A8A8A',
              fontSize: '14px',
              margin: 0,
              lineHeight: 1.6,
            }}>
              We use cookies to enhance your browsing experience and analyze our traffic. 
              By clicking "Accept All", you consent to our use of cookies.{' '}
              <a 
                href="/privacy" 
                style={{ 
                  color: '#F1F1F1', 
                  textDecoration: 'underline',
                }}
              >
                Privacy Policy
              </a>
            </p>
          </div>
          
          {/* Buttons */}
          <div style={{ 
            display: 'flex', 
            gap: '12px',
            flexWrap: 'wrap',
          }}>
            <button
              onClick={declineCookies}
              style={{
                padding: '12px 24px',
                backgroundColor: 'transparent',
                border: '1px solid #333',
                borderRadius: '4px',
                color: '#8A8A8A',
                fontSize: '14px',
                cursor: 'pointer',
                fontFamily: "'TASA Orbiter Display', sans-serif",
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = '#F1F1F1';
                e.target.style.color = '#F1F1F1';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = '#333';
                e.target.style.color = '#8A8A8A';
              }}
            >
              Decline
            </button>
            <button
              onClick={acceptCookies}
              style={{
                padding: '12px 24px',
                backgroundColor: '#F1F1F1',
                border: 'none',
                borderRadius: '4px',
                color: '#0D0D0D',
                fontSize: '14px',
                cursor: 'pointer',
                fontFamily: "'TASA Orbiter Display', sans-serif",
                fontWeight: '500',
                transition: 'opacity 0.2s ease',
              }}
              onMouseEnter={(e) => e.target.style.opacity = '0.9'}
              onMouseLeave={(e) => e.target.style.opacity = '1'}
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;